/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_SniffInputs */

const fr_rapid_eager_otter_sniff = /** @type {(inputs: Rapid_Eager_Otter_SniffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors de l'annulation de votre abonnement. Veuillez réessayer plus tard.`)
};

/**

* @param {Rapid_Eager_Otter_SniffInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_sniff = /** @type {((inputs?: Rapid_Eager_Otter_SniffInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_SniffInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_sniff(inputs)
});